export default __webpack_public_path__ + "static/media/GOOGLE_PLAY_STORE_BADGE_EN.1d8f7bc8.svg";